import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import PageContainer from "../layout/PageContainer";
import SearchForm from "../search/SearchForm";
import SearchResults from "../search/SearchResults";
import useSearch from "../../hooks/useSearch";

export default function DashboardHome() {
    const {
        searchTerm,
        setSearchTerm,
        count,
        setCount,
        results,
        error,
        loading,
        hasSearched,
        handleSearch,
        handleExport,
        handleLoadMore,
        hasMore,
        aiModel,
        markAsLinkList,
        marking,
        markError,
        markSuccess,
        setMarkError,
        setMarkSuccess,
        blockDomain,
    } = useSearch();

    return (
        <PageContainer title="Suche" breadcrumbs={["Home", "Suche"]}>
            <Grid container spacing={3}>
                {/* Suchformular */}
                <Grid item xs={12}>
                    <Paper sx={{ p: 3 }}>
                        <SearchForm
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            count={count}
                            setCount={setCount}
                            handleSearch={handleSearch}
                            error={error}
                            loading={loading}
                            aiModel={aiModel}
                        />
                    </Paper>
                </Grid>

                {hasSearched && (
                    <Grid item xs={12}>
                        <Paper sx={{ p: 3 }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={2}
                            >
                                <Typography variant="h6">Ergebnisse</Typography>
                            </Box>

                            <Box
                                sx={{
                                    overflow: "visible",   // keine Scrollbars
                                    height: "auto",        // wächst mit dem Inhalt
                                    maxHeight: "none",     // keine Begrenzung
                                    pr: 0,                 // kein padding nötig
                                }}
                            >
                                <SearchResults
                                    results={results}
                                    handleExport={handleExport}
                                    loading={loading}
                                    hasMore={hasMore}
                                    handleLoadMore={handleLoadMore}

                                    onBlockDomain={blockDomain}

                                    onMarkLinkList={markAsLinkList}
                                    marking={marking}
                                    markError={markError}
                                    markSuccess={markSuccess}
                                    clearMarkMessages={() => {
                                        setMarkError("");
                                        setMarkSuccess("");
                                    }}
                                />
                            </Box>
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </PageContainer>
    );
}
